import Vue from "vue"
import {
    generate
} from "generate-password"

Vue.prototype.$generate = args => {
    return generate(args)
}